<template>
  <svg
    class="main-svg"
    width="100%"
    height="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 1080L1256 0H1920V1080H0Z" />
  </svg>
  <svg
    class="second-svg"
    width="768"
    height="952"
    viewBox="0 0 768 952"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="-612.519"
      y="408.891"
      width="1852.11"
      height="688.185"
      transform="rotate(-12.7343 -612.519 408.891)"
      fill="white"
    />
  </svg>
  <div class="background">
    <div class="fourzerofour">
      <div class="error">{{ $t("error.error") }}</div>
      <svg
        width="167"
        height="69"
        viewBox="0 0 167 69"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M49.7 50.9C48.9 50.7 45.5667 50.5333 39.7 50.4V68.1H28.1V50.4H0.8V48.3L38.1 0.899998H39.7V40.1H40.5C42.3 40.1 43.6333 39.9667 44.5 39.7C45.4333 39.4333 46.0667 39 46.4 38.4C46.7333 37.8 47 36.8667 47.2 35.6H49.3C49.3 42.6667 49.4333 47.7667 49.7 50.9ZM28.1 40.1V16.8L10 40.1H28.1ZM85.632 0.899998C90.8987 0.899998 95.5987 2 99.732 4.2C103.865 6.4 107.065 9.5 109.332 13.5C111.665 17.5 112.832 22.1 112.832 27.3C112.832 32.6333 111.632 37.4333 109.232 41.7C106.899 45.9667 103.565 49.3333 99.232 51.8C94.9654 54.2 90.0654 55.4 84.532 55.4C79.332 55.4 74.6654 54.3 70.532 52.1C66.3987 49.9 63.1654 46.8 60.832 42.8C58.4987 38.8 57.332 34.1667 57.332 28.9C57.332 23.6333 58.4987 18.8667 60.832 14.6C63.232 10.3333 66.5654 7 70.832 4.6C75.0987 2.13333 80.032 0.899998 85.632 0.899998ZM84.732 2.7C82.332 2.7 80.1987 3.73333 78.332 5.8C76.4654 7.86666 74.9987 10.8667 73.932 14.8C72.932 18.6667 72.432 23.2667 72.432 28.6C72.432 37.0667 73.632 43.3667 76.032 47.5C78.4987 51.5667 81.632 53.6 85.432 53.6C87.832 53.6 89.932 52.5667 91.732 50.5C93.5987 48.3667 95.0654 45.3667 96.132 41.5C97.1987 37.5667 97.732 32.9333 97.732 27.6C97.732 19.1333 96.4987 12.8667 94.032 8.8C91.632 4.73333 88.532 2.7 84.732 2.7ZM166.204 50.9C165.404 50.7 162.071 50.5333 156.204 50.4V68.1H144.604V50.4H117.304V48.3L154.604 0.899998H156.204V40.1H157.004C158.804 40.1 160.137 39.9667 161.004 39.7C161.937 39.4333 162.571 39 162.904 38.4C163.237 37.8 163.504 36.8667 163.704 35.6H165.804C165.804 42.6667 165.937 47.7667 166.204 50.9ZM144.604 40.1V16.8L126.504 40.1H144.604Z"
          fill="white"
        />
      </svg>
    </div>
    <!-- <div class="crash">
      <img class="crash-icon" src="../../assets/crash.png">
    </div> -->
    <div class="information-wrapper">
      <div class="not-found">{{ $t("not-found.not-found") }}</div>
      <div class="text-prompt">
        {{ $t("error.search") }}
      </div>
      <div class="search">
        <form @submit.prevent="handleSearch">
          <input
            type="text"
            class="search-input"
            v-model="query"
            :placeholder="$t('error.input')"
          />
          <button type="submit">
            <i class="far fa-search"></i>
          </button>
        </form>
      </div>
      <div class="back-to">{{ $t("error.orback") }}</div>
      <div>
        <!-- <button
          v-wave="{
            color: 'currentColor',
            easing: 'ease-out',
            duration: 0.4,
            initialOpacity: 0.2,
            finalOpacity: 0.4,
            cancellationPeriod: 75,
          }"
          v-if="hasBack()"
          @click="$router.go(-1)"
          class="flat-btn back-button"
        >
          <i class="far fa-chevron-left"></i>
          <h2 class="backup">
            {{ $t("main.return") }}
          </h2>
        </button> -->
        <router-link
          :to="
            $i18nRoute({
              name: 'MainWrapper',
              params: { category: 'feed' },
            })
          "
          class="flat-btn back-button"
        >
          <i class="far fa-chevron-left"></i>
          <h2 class="backup">
            {{ $t("main.return") }}
          </h2>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useLanguage } from "@/utils/language";

export default {
  setup() {
    const query = ref("");
    const router = useRouter();

    const { i18n } = useLanguage();

    const handleSearch = () => {
      router.push({
        name: `${i18n.global.locale.value || i18n.global.locale}_SearchQuery`,
        params: { query: query.value, category: "feed" },
      });
    };

    return {
      handleSearch,
      query,
    };
  },
};
</script>

<style lang="scss" scoped>
.main-svg {
  position: fixed;
  top: 0;
  left: 0;
  fill: var(--background-color);
  transform: matrix(1.2, 0, 0, 1, 0, 0);

  path {
    fill: var(--foreground-color);
  }
}
.second-svg {
  display: none;
}

// .crash{
//   display: block;
//   position: absolute;
//   z-index: 1;
//   margin: 100px 0 0 -400px;
//   isolation: isolate;

//   .crash-icon {
//     background-color: transparent;
//   }
// }

.background {
  display: flex;
  position: relative;
  width: 100%;
  z-index: 2;
  height: 100%;
  min-height: 100vh;
  justify-content: center;
  align-items: center;
  mix-blend-mode: difference;
  font-family: Alice;

  .fourzerofour {
    position: relative;
    z-index: 3;
    .error {
      font-size: 45px;
      position: absolute;
      padding-top: 170px;
      margin: 0 0 0 60px;
    }

    svg {
      width: 1000px;
      height: 700px;
      transform-origin: top right;
      transform: scale(0.9);
    }
  }
  .information-wrapper {
    width: 500px;
    height: auto;
    position: relative;
    text-align: center;
    font-family: Open Sans;
    padding-left: 80px;
    padding-bottom: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;

    // background-color: yellowgreen;
    .not-found {
      font-size: 2.2rem;
    }
    .text-prompt {
      padding-top: 50px;
      font-size: 1.5rem;
    }
    .back-to {
      padding-top: 50px;
      font-size: 1.5rem;
    }
    .search {
      margin: 30px 0 0 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background: none;
      border-radius: 3px;
      width: 100%;
      border: 1px solid white;

      button {
        width: 40px;
        height: 48px;
        border-radius: 10px;
        background: none;
        color: white;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
      .search-input {
        height: 48px;
        width: 400px;
        background: none;
        outline: none;
        color: white;
        font-size: 24px;
      }
    }
    .back-button {
      display: flex;
      position: relative;
      justify-content: center;
      align-items: center;
      margin-top: 25px;
      padding: 20px 26px;
      font-size: 1.8em;
      color: unset;
      text-transform: uppercase;

      .backup,
      i {
        mix-blend-mode: difference;
        margin: 0 0.25em;
      }
    }
  }
}

@media screen and (max-width: 1600px) {
  .main-svg {
    position: fixed;
    top: 0;
    left: 0;
    fill: var(--background-color);
    transform: matrix(1.5, 0, 0, 1, -250, 1);

    path {
      fill: var(--foreground-color);
    }
  }
  .background {
    .fourzerofour {
      .error {
        font-size: 30px;
        padding-top: 130px;
        margin: 0 0 0 80px;
      }
      svg {
        width: 800px;
        height: 600px;
        transform-origin: top right;
        transform: scale(0.9);
      }
    }

    .information-wrapper {
      width: 450px;
      padding-left: 80px;
      padding-bottom: 50px;

      .not-found {
        font-size: 1.8rem;
      }

      .text-prompt {
        padding-top: 50px;
        font-size: 1.2rem;
      }

      .back-to {
        padding-top: 50px;
        font-size: 1.2rem;
      }
    }
  }
}

@media screen and (max-width: 1366px) {
  .main-svg {
    transform: matrix(-1, 0, 0, 1, 0, 0);

    path {
      fill: var(--foreground-color);
    }
  }

  .background {
    .fourzerofour {
      .error {
        font-size: 25px;
        padding-top: 70px;
        margin: 0 0 0 70px;
      }
      svg {
        width: 600px;
        height: 400px;
        transform-origin: top right;
        transform: scale(0.9);
      }
    }

    .information-wrapper {
      width: 350px;
      padding-left: 40px;
      padding-right: 40px;

      .not-found {
        font-size: 1.3rem;
      }
      .text-prompt {
        padding-top: 20px;
        font-size: 1rem;
      }
      .back-to {
        padding-top: 30px;
        font-size: 1rem;
      }
      .search {
        margin: 30px 0 0 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: none;
        border-radius: 3px;
        width: 100%;
        border: 1px solid white;

        button {
          width: 40px;
          height: 48px;
          border-radius: 10px;
          background: none;
          color: white;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
        .search-input {
          height: 48px;
          width: 260px;
          background: none;
          outline: none;
          color: white;
          font-size: 14px;
        }
      }
      .back-button {
        display: flex;
        position: relative;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        padding: 20px 26px;
        font-size: 1.8em;
        color: unset;
        text-transform: uppercase;

        .backup,
        i {
          mix-blend-mode: difference;
          margin: 0 0.25em;
        }
      }
    }
  }
}

@media screen and (max-width: 992px) {
  .main-svg {
    display: none;
  }
  .second-svg {
    width: 100%;
    height: 100%;
    display: block;
    position: fixed;
    fill: var(--background-color);
  }

  .background {
    width: 100%;
    z-index: 2;
    height: 100%;
    mix-blend-mode: difference;
    flex-direction: column;
    font-family: Alice;
    .fourzerofour {
      .error {
        font-size: 35px;
        padding-top: 10px;
        margin: 0;
      }
      svg {
        width: 600px;
        height: 200px;
        transform: scale(1);
        padding-bottom: 50px;
      }
    }

    .information-wrapper {
      width: 500px;
      padding-bottom: 100px;

      .not-found {
        font-size: 2.2rem;
      }
      .text-prompt {
        padding-top: 20px;
        font-size: 1.7rem;
      }
      .back-to {
        padding-top: 30px;
        font-size: 1.7rem;
      }
      .search {
        margin: 30px 0 0 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: none;
        border-radius: 3px;
        width: 350px;
        border: 1px solid white;

        button {
          width: 40px;
          height: 48px;
          border-radius: 10px;
          background: none;
          color: white;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
        .search-input {
          height: 48px;
          width: 260px;
          background: none;
          outline: none;
          color: white;
          font-size: 16px;
        }
      }

      .back-button {
        justify-content: center;
        align-items: center;
        margin-top: 60px;
        padding: 20px 26px;
        font-size: 1.8em;
        color: unset;
        text-transform: uppercase;

        .backup,
        i {
          mix-blend-mode: difference;
          margin: 0 0.25em;
        }
      }
    }
  }
}

@media screen and (max-width: 620px) {
  .second-svg {
    width: 690px;
    height: 900px;
    display: block;
    position: fixed;
    fill: var(--background-color);
    transform: matrix(1, 0, 0, 0.7, 0, -100);
  }

  .background {
    display: flex;
    position: absolute;
    width: 100%;
    z-index: 2;
    height: 100%;
    justify-content: center;
    align-items: center;
    mix-blend-mode: difference;
    flex-direction: column;
    font-family: Alice;
    .fourzerofour {
      .error {
        font-size: 18px;
        padding-top: 2px;
        margin: 0 0 0 -15px;
        transform-origin: unset;
        transform: unset;
      }
      svg {
        width: 300px;
        height: 130px;
        transform: scale(0.8);
        margin: 0 0 0 -50px;
        padding-bottom: 0;
      }
    }

    .information-wrapper {
      width: 70%;
      padding-bottom: 210px;

      .not-found {
        font-size: 1.3rem;
      }
      .text-prompt {
        padding-top: 10px;
        font-size: 1rem;
      }
      .back-to {
        padding-top: 30px;
        font-size: 1rem;
      }
      .search {
        margin: 30px 0 0 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: none;
        border-radius: 3px;
        width: 240px;
        border: 1px solid white;

        button {
          width: 40px;
          height: 38px;
          border-radius: 10px;
          background: none;
          color: white;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
        .search-input {
          height: 38px;
          width: 180px;
          background: none;
          outline: none;
          color: white;
          font-size: 14px;
        }
      }

      .back-button {
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        padding: 8px 12px;
        font-size: 1.4em;
        color: unset;
        text-transform: uppercase;

        .backup,
        i {
          mix-blend-mode: difference;
          margin: 0 0.25em;
        }
      }
    }
  }
}
</style>
